// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- UI Components
import LottiePlayer from "@dtci/spellbook/LottiePlayer";
// --- Styles
import styles from "./spinner.module.scss";

/**
 * Spinner component that conditionally renders a loading animation.
 *
 * @returns {JSX.Element|null} The rendered Spinner component or null if hidden.
 */
export const Spinner = () => {
  const { showSpinner } = useSelector((s) => s.spinner);
  if (!showSpinner) return null;

  return (
    <div className={styles.container}>
      <div className={styles.spinnerWrapper}>
        <LottiePlayer />
      </div>
    </div>
  );
};
